import React, { PropTypes } from "react";

const PreviousWebinarsView = ({
  webinars,
  nextPage,
  pagination,
  count,
  sponsor,
  sponsors,
  onFilterChange,
}) => (
  <div>
    {!webinars.length && (
      <div style={{ marginTop: "48px" }}>
        <p className="group-no-webinars">
          There are no webinars currently available to watch on demand
        </p>
      </div>
    )}
    {/*<div className="section_webinars_sponsors_filter">*/}
    {/*  <SelectField*/}
    {/*    value={sponsor}*/}
    {/*    options={sponsors}*/}
    {/*    field_name="sponsor"*/}
    {/*    label={'Filter by sponsors'}*/}
    {/*    onChange={onFilterChange}*/}
    {/*  />*/}
    {/*</div>*/}
    {!!webinars.length && (
      <div className="container_previous">
        {webinars}
        {pagination && (
          <a className="more_item" href="javascript:void(0)" onClick={nextPage}>
            LOAD MORE
          </a>
        )}
      </div>
    )}
  </div>
);

PreviousWebinarsView.propTypes = {
  webinar: PropTypes.obj,
  onFilterChange: PropTypes.func,
};

export default PreviousWebinarsView;



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Recorded/PreviousWebinarsView.js